function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.933333 0 0 0 0 0.933333 0 0 0 0 0.933333 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Welcome",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "coz_logo",
  transform: "translate(-669.000000, -963.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(669.000000, 963.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(1.304087, 1.208729)",
  stroke: "#FFFFFF",
  strokeWidth: 1.58538953
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-7",
  x: 3.21964677e-15,
  y: 5.55111512e-16,
  width: 100.511444,
  height: 29.1319156
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(38.259952, 8.463661)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  stroke: "#FFFFFF",
  strokeWidth: 0.5,
  points: "53.0893182 0.276006124 53.0893182 2.70675269 44.221939 11.6701306 53.0893182 11.6701306 53.0893182 14.4654892 40.5099214 14.4654892 40.5099214 12.0347426 49.317366 3.101749 40.9972588 3.101749 40.9972588 0.276006124"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.634512,3.08642001e-12 C31.584222,3.08642001e-12 34.9876955,3.3978139 34.9876955,7.34095596 C34.9876955,11.284098 31.584222,14.6819119 27.634512,14.6819119 C23.6848021,14.6819119 20.2813286,11.284098 20.2813286,7.34095596 C20.2813286,3.3978139 23.6848021,3.08642001e-12 27.634512,3.08642001e-12 Z M27.634512,3.12514982 C25.428557,3.12514982 23.4326929,5.11769501 23.4326929,7.3199818 C23.4326929,9.52226859 25.428557,11.5357879 27.634512,11.5357879 C29.8404671,11.5357879 31.8363312,9.52226859 31.8363312,7.3199818 C31.8363312,5.11769501 29.8404671,3.12514982 27.634512,3.12514982 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8406934,9.63556736 L14.3492123,9.63556736 C13.3827939,12.5719497 10.6095933,14.6903399 7.35318347,14.6903399 C3.29842802,14.6903399 -1.34718887e-13,11.3973968 -1.34718887e-13,7.34938393 C-1.34718887e-13,3.30137108 3.29842802,0.00842797391 7.35318347,0.00842797391 C10.6095933,0.00842797391 13.3617848,2.10584396 14.3282032,5.02125219 L10.8196843,5.02125219 C10.2314296,3.74182843 8.80281107,2.94481036 7.35318347,2.94481036 C5.04218295,2.94481036 3.19338254,4.93735555 3.19338254,7.34938393 C3.19338254,9.78238648 5.04218295,11.7539575 7.35318347,11.7539575 C8.82382017,11.7539575 10.2524387,10.894017 10.8406934,9.63556736 Z",
  id: "Path",
  stroke: "#FFFFFF",
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M30.1965411,0.263418007 L30.727823,30.8577755 L0.800516955,31.3828549 L0.269235035,0.788497404 L30.1965411,0.263418007 Z M7.1894228,11.7940991 L4.42959567,14.6519838 L10.0864086,20.1134156 L4.56646441,25.8301938 L10.1545531,25.7035295 L15.6742073,19.9877602 L7.1894228,11.7940991 Z M23.8726452,17.0519955 L18.4174814,22.711388 L23.9241416,22.6210105 L26.7019118,19.7012738 L23.8726452,17.0519955 Z M18.2565538,5.94855079 L15.4968341,8.80525016 L12.6684652,6.07521507 L9.90863806,8.93309972 L18.3934226,17.1267608 L21.1532497,14.2688762 L18.3252781,11.5366469 L21.0848153,8.67977117 L18.2565538,5.94855079 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  transform: "translate(15.498529, 15.823136) rotate(1.000000) translate(-15.498529, -15.823136) "
}))));

function SvgCozLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "103px",
    height: "32px",
    viewBox: "0 0 103 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coz_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCozLogo);
export default __webpack_public_path__ + "static/media/coz_logo.1a7460b3.svg";
export { ForwardRef as ReactComponent };